import { Gender, Telephone, Address, DocumentType, Sport, SportPosition, StaffPosition, PersonSegment } from '@api/domain';
import { DocumentFile } from '../../app/helpers';

export class Patient {
  id?: number;
  name: string;
  surname: string;
  documentType: DocumentType;
  numberDocument: number;
  gender: Gender;
  birthday: string;
  age?: number;
  email: string;
  telephones?: Telephone[];
  address?: Address[];
  urlAvatarProfile?: string;
  sport?: Sport;
  position?: SportPosition;
  instituteId?: string;
  lastEvaluationDate: Date;
  licenseNumber?: string;
  staffPosition: StaffPosition;
  personSegment: PersonSegment
  imageDTO: DocumentFile
  selfManagementDiet?: boolean;
  mercadoPagoLink?: string;
  professionalMercadoPagoLink?: string;
  checked: any
}

export class PatientBasicData {
  email: string;
  telephones: Telephone[];
  sport?: Sport;
  position?: SportPosition;
  personSegment?: PersonSegment;
}

export interface NewConsultationDto {
  id?: number;
  creationDate?: string;
  patientId: number;
  profesionalId: number;
  evaluationId?: number;
  objectiveId?: number;
  observation?: string;
}

export enum PersonType {
  patient = "Patient",
  staff = "Staff",
}

export interface emailDto {
  lastEmail: string,
  newEmail: string
}
export interface GenericPersonDataDTO {
  id: number;
  name: string;
  surname: string;
  documentType: DocumentType;
  numberDocument: number;
  gender: Gender;
  urlAvatarProfile: string | null;
  lastEvaluationDate: string | null;
  email: string;
  telephones: Telephone[];
  staffPosition: StaffPosition;
  imageDTO: DocumentFile;
}

export interface PersonListResponse {
  totalElements: number;
  totalPages: number;
  genericPersonDataDTOList: GenericPersonDataDTO[];
}
